import './spinner.css'
import * as React from 'react'

function spinner(props: any) {
    if (!!props.show) {
        return (
            <div className="typing_loader"></div>
        );
    } else {
        return null;
    }
}

export const Spinner = spinner;


// WEBPACK FOOTER //
// ./src/components/spinner.tsx